export const ITEMS = [
    {
        caption: 'Data',
        title: 'Build on a solid foundation with Vulners data',
        description:
            'We provide the essential building blocks for cybersecurity solutions with comprehensive, structured, and constantly updated vulnerability and exploits data'
    },
    {
        caption: 'Api',
        title: 'Power your application with Vulners API',
        description:
            'The Vulners REST API offers reliable, high-performance access to vulnerability intelligence, with 99.9% SLA uptime and CDN-backed data delivery for seamless global access'
    },
    {
        caption: 'App',
        title: 'Assess and manage vulnerabilities with Vulners tools',
        description:
            "Built on top of Vulners' database and SDK, end-user solutions give security professionals and developers lightweight and powerful tools for vulnerability remediation"
    }
];
